import React, { useState, useEffect, createContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Breadcrumbs from "./Breadcrumbs";
import FinancialDataCardSummary from "./FinancialDataCardSummary";
import ERPServicesList from "./ERPServicesList";
import { useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { generateInvoiceExcel } from "../../utils/generateInvoiceExcel";
// import { FaArrowLeft } from "react-icons/fa";
import {
  getAllSalesOrder,
  getFinalBillObject,
  getInvPDF,
  getInvPDFObject,
  printPDFFile,
  successDispatch,
} from "./ERPActions/erpActions";
import ERPVisitFinancialSummary from "./erpVisitFinancialSummary";
import ERPInvoice from "./ERPInvoice";
import {
  HMS_ERP_BILL_CLEAR_ADVANCE_TYPE,
  ERP_INVOICE_BILLING_STAGE_BACK_TO_BILLING_FROM_PAYMENT,
  ERP_INVOICE_WORKING_DATA_TYPE_SO_GENERATE_INVOICE,
  ERP_INVOICE_WORKING_DATA_TYPE_VIEW_INVOICE,
  ERP_LABEL_NEW_INVOICE,
  ERP_LABEL_PAYMENT_BACK_ICON,
  ERP_LABEL_PAYMENT_CLOSE_ICON,
  ERP_LABEL_SERVICES,
  ERP_LABEL_VIEW_INVOICE,
  ERP_LABEL_VISIT_FIN_SUMMARY,
  ERP_LOCATION_MAP_LOCATION_NAME,
  ERP_OUTSTANDING_BILLS_TYPE_DIRECT_CLEAR,
  ERP_PAYMENT_PAGE_TYPE_BACK_PAYMENT,
  ERP_PAYMENT_PAGE_TYPE_CLOSE_PAYMENT,
  ERP_TABLE_NEW_INVOICE_ITEMS,
  ERP_VISIT_FIN_SUMMARY_TYPE_INV,
  ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE,
  ERP_VISIT_FIN_SUMMARY_TYPE_SO,
  PATIENT_VISIT_INTERNAL_STATUS_MOVED_TO_BILLING,
  PATIENT_VISIT_TYPE_IN_PATIENT,
  ERP_BILLING_TYPE_SO,
  PATIENT_VISIT_INTERNAL_STATUS,
  PATIENT_VISIT_TYPE,
  FINANCIALCARDSUMMARYTITLE,
  INVOICE_REPORT_TYPE,
  INVOICE_REPORT_TYPE_LABEL,
  PATIENT_VISIT_STATUS,
  HMS_ERPPAYMENT_PAYMENT_TYPE,
  ERP_LABEL_ADVANCE_REQUEST,
  HMS_REPORT_TEMPLATE_TYPE,
  PAGE_MODE,
  ERP_LOCATION_NAME_TO_LOCATION_ID_MAP,
  ERP_LABEL_MOVETOBILL,
  ERP_OUT_PATIENT_BILLING_LOC_NAME,
  ERP_IN_PATIENT_BILLING_LOC_NAME,
  MASTER_LOCATION_DATA_LOCATION_KEY,
  VISIT_BILLING_STATUS,
} from "../../core/constants/erpConstants";
import { patientActions } from "../../core/actions";
import { doctorActions } from "../../core/actions"; // imported to query assignRoom status
import ERPPayment from "./ERPPayment";
import ERPProductSearch from "./ERPProductSearch";
import HMSPaymentRequest from "./hmspaymentrequest/HMSPaymentRequest";
import MembershipServices from "./MembershipServices";
import MessageStrip from "../../shared/messagestrip/MessageStrips";
import { Alert, FormControl, Select, MenuItem } from "@mui/material";
import Filter from "./Filter";
import { Loading } from "./Loading";
import { Button } from "@material-ui/core";
import helperServices from "../../shared/helper/helper";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {
  All_Component_Name,
  COMPONENT_TYPE_COMPONENT,
  COMPONENT_TYPE_NULL,
  LAB_ADMIN,
  ORG_CODES,
  ORG_DETAILS,
  RADIOLOGY,
  ROLE_KEYS,
} from "../../shared/constants";
import ProtectedComponent from "../common/ProtectedComponent";
import { set } from "lodash";
import { tr, vi } from "date-fns/locale";
import { generateBillHtml } from "../printConvertion/DocumentConvert";
import HeaderFooterComponent from "../printConvertion/HeaderAndFooter";
import { useOrganization } from "../../configurations/OrganizationContext";
import Components from "..";
import ErrorScreen from "../../shared/helper/ErrorScreen";
import { insuranceServices } from "../../core/services";
import InvoiceViewer from "./InvoiceViewer";
import { getMasterLocationDetails } from "./ERPActions/erpServices";

const hasInvoiceItems = (reports = []) =>
  reports.some(
    (report) =>
      Array.isArray(report?.billingItem) && report.billingItem.length > 0,
  );

const sumReportField = (reports, field) =>
  reports.reduce(
    (total, report) => total + Number(report?.billSummary?.[field] || 0),
    0,
  );

// Membership services are invoiced directly and therefore have no ERP sales
// order. The ERP estimate endpoint reads sales orders, so consolidate the
// finalized invoice DTOs into one estimate only when that endpoint is empty.
const buildEstimateFromInvoices = (reports = []) => {
  if (!hasInvoiceItems(reports)) return [];

  const firstReport = reports[0];
  const billingItem = reports
    .flatMap((report) => report?.billingItem || [])
    .map((item, index) => ({ ...item, slNo: index + 1 }));

  return [
    {
      ...firstReport,
      customerDetail: {
        ...firstReport.customerDetail,
        billNumber: "",
        billDate: "",
      },
      billingItem,
      billSummary: {
        ...firstReport.billSummary,
        total: sumReportField(reports, "total"),
        discount: sumReportField(reports, "discount"),
        roundOff: sumReportField(reports, "roundOff"),
        tax: sumReportField(reports, "tax"),
        billAmount: sumReportField(reports, "billAmount"),
        receivedAmount: 0,
        paymentAmount: 0,
        paidAmount: 0,
        advancePayment: 0,
        billAmountInWords: "",
        amountWords: "",
        paymentsList: [],
        invoicePayments: [],
      },
    },
  ];
};

export const DataContext = createContext();

export default function ERPBilling() {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const returnTo = urlParams.get("returnTo");
  // Use state so we can clear the quote ID once it has been seeded into the
  // grid. A plain const never changes after mount, so ERPInvoice would keep
  // receiving the same fromQuoteId prop and re-seed on every remount.
  const [fromQuoteId, setFromQuoteId] = useState(() => urlParams.get("fromQuote"));
  const fromLocKey = urlParams.get("locKey");

  const handleBack = () => {
    if (returnTo) {
      window.location.href = decodeURIComponent(returnTo);
    } else {
      window.history.back();
    }
  };
  const org = useOrganization();
  const isVedamaayu =
    org?.orgCode?.toLowerCase() === ORG_CODES.VEDAMAAYU;

  const dispatch = useDispatch();
  // const { patientDetails, loading: patientLoading, error: patientError } = useSelector(state => state.patient);
  const { patientId, visitId } = useParams();
  const requestedTab = urlParams.get("tab");
  const [value, setValue] = React.useState(() => {
    if (requestedTab === "membership" && isVedamaayu) return "5";
    if (requestedTab === "3") return "3";
    return "2";
  });
  const [showMsgStrip, setShowMsgStrip] = useState(false);
  const [messageDetails, setMessageDetails] = useState({});
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  const [totalAdvPaid, setTotalAdvPaid] = useState(0.0);
  const [allFinSummaryData, setAllFinSummaryData] = useState({});
  const [balanceAmount, setBalanceAmount] = useState(0.0);
  const [currentDate, setCurrentDate] = useState(new Date());
  // const [ticketIdsForPrint, setTicketIdsForPrint] = useState([]);
  const [printDataPayload, setPrintDataPayload] = useState({
    invoiceTicketIds: [],
    advanceRefundRows: []
  });
  // Convert totalBillAmt to a state variable
  const [totalBillAmt, setTotalBillAmt] = useState(0.0);
  const [totalWithoutDiscount, setTotalWithoutDiscount] = useState(0.0);
  const [totalDiscountAmount, setTotalDiscountAmount] = useState(0.0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState([]);
  // const [locationDetails, setLocationDetails] = useState([]);
  const [breadcrumbItems, setBreadcrumbItems] = useState();
  const [showPayment, setShowPayment] = useState(false);
  const [showOutstandingBill, setShowOutstandingBill] = useState(false);
  const [billClearAmtOverride, setBillClearAmtOverride] = useState();
  const [productSelected, setProductSelected] = useState();
  const [invoiceViewTabName, setInvoiceViewTabName] = useState(false);
  const [invoicePaymentDetails, setInvoicePaymentDetails] = useState();
  const [visitList, setVisitList] = useState();
  const [invoiceCount, setInvoiceCount] = useState(0);
  const currentUserRole = helperServices.getRole();
  const [paymentInitialisedMode, setPaymentInitialisedMode] = useState();
  const searchInputRef = useRef(null);
  const patientBasicInfo = useSelector(
    (state) => state.patientDetailsState.patientBasic,
  );
  const newInvoiceItems = useSelector(
    (state) => state.erpDetailsState?.erpNewInvoiceItems,
  );
  const allMasterLocationDetails = useSelector(
    (state) => state.erpDetailsState?.masterLocationDetails,
  );
  const [triggerAction, setTriggerAction] = useState("");
  const [isDisable, setIsDisable] = useState(false);
  const [isBackgroundTransparent, setIsBackgroundTransparent] = useState(false);
  const [onMoveToBillModalOpen, setOnMoveToBillModalOpen] = useState(false);
  // const [roomDealocateModalOpen, setRoomDealocateModalOpen] = useState(false);
  const [openRoomDealocate, setOpenRoomDealocate] = useState(false);
  const [roomInfo, setRoomInfo] = useState(null); // store assigned room details for deallocation logic
  const [errorMessages, setErrorMessages] = useState("");
  const [InsurerData, setInsurerData] = useState(null);
  const [hikeUpService, setHikeUpService] = useState(false);
  const [printdata, setPrintData] = useState("");
  const [isKpCash, setIsKpCash] = useState(true);
  const [isDischarged, setIsDischarged] = useState(false);
  const [isRoomBooked, setIsRoomBooked] = useState(false);
  const [visitStatus, setVisitStatus] = useState();
  useEffect(() => {
    // if (
    //   patientBasicInfo?.type?.toLowerCase() ===
    //   PATIENT_VISIT_TYPE.INPATIENT.toLowerCase()
    // ) {
    //   setIsKpCash(false);
    // } else {
    //   setIsKpCash(true);
    // }
  if (!patientBasicInfo?.visitList || !visitId) {
    setVisitStatus(undefined);
    return;
  }

  const matchedVisit = patientBasicInfo.visitList.find(
    (visit) => String(visit.id) === String(visitId)
  );

  if (!matchedVisit) {
    console.warn("Visit not found for visitId:", visitId);
    setVisitStatus(undefined);
    return;
  }

  setVisitStatus(matchedVisit.internalStatus);


    const isKpCashEnabled = helperServices.getEnableKpCash(
      patientBasicInfo?.type,
      org?.billing,
      org?.orgCode,
    );

    setIsKpCash(isKpCashEnabled);
  }, [patientBasicInfo,visitId]);

  useEffect(() => {
    console.log(`Selected ${isKpCash ? "Cash" : "Credit"}`);
  }, [isKpCash]);

  //  const loadRoomInfo = () => {
  //   if (visitId) {
  //         const patientData = {  visitid:visitId};
  //         dispatch(
  //           doctorActions.getAssignedRoom(patientData, (resCb) => {
  //             if (resCb) {
  //               console.log("Assigned Room Info: ", resCb);

  //             }
  //           }) )
  //   }
  // };

  const loadRoomInfo = () => {
    if (visitId) {
      let data = { visitId: visitId };
      dispatch(
        doctorActions.getAssignedRoom(data, (resCb) => {
          if (resCb) {
            console.log("Assigned Room Info: ", resCb);
            if (resCb?.room?.roomStatus?.bookstatus === "booked") {
              setIsRoomBooked(true);
            } else {
              setIsRoomBooked(false);
            }
          }
        }),
      );
    }
  };

  useEffect(() => {
    getPatientProfile();
    loadRoomInfo();
    // fetchData();
    if (requestedTab === "membership" && isVedamaayu) {
      setValue("5");
    } else if (requestedTab === "3") {
      setValue("3");
    } else {
      setValue("2");
    }
    // let currentRole = helperServices.getRole();
    // setCurrentUserRole(currentRole)
    console.log("currentBillingRole: ", currentUserRole);
    // if (ROLE_KEYS.InsuranceDesk === currentUserRole) {
    //   setInvoiceViewTabName(true);
    // }
    let locationList = Object.keys(ERP_LOCATION_MAP_LOCATION_NAME);
    setSelectedLocation(locationList);
    setCurrentDate(new Date());
  }, [patientId, visitId, requestedTab, isVedamaayu]);

  useEffect(() => {
    const handleGlobalKeyDown = (event) => {
      if (event.key === "F2" || event.keyCode === 113) {
        if (value === "1" || value === "3") {
          event.preventDefault();
          if (searchInputRef.current) {
            try {
              searchInputRef.current.focus();
            } catch (e) {}
          }
        }
      } else if (event.key === "F3" || event.keyCode === 114) {
        event.preventDefault();
        handleChange("1"); // Services tab
      } else if (event.key === "F4" || event.keyCode === 115) {
        event.preventDefault();
        handleChange("2"); // Visit Financial Summary tab
      } else if (event.key === "F5" || event.keyCode === 116) {
        event.preventDefault();
        handleChange("3"); // New/View Invoice tab
      }
    };
    window.addEventListener("keydown", handleGlobalKeyDown);
    return () => window.removeEventListener("keydown", handleGlobalKeyDown);
  }, [value]);

  useEffect(() => {
    if (currentUserRole === ROLE_KEYS.LabAdmin) {
      setValue("3");
    }
  }, [currentUserRole]);

  useEffect(() => {
    setIsDischarged(
      patientBasicInfo?.visit?.billingStatus ===
        VISIT_BILLING_STATUS.BILLING_STATUS_DISABLED,
    );
    setBreadcrumbItems(getBreadcrumbItems(value));
  }, [patientBasicInfo]);
  // Update the useEffect that watches for changes
  useEffect(() => {
    const newBalance = totalAdvPaid - totalBillAmt;
    setBalanceAmount(newBalance);
  }, [totalAdvPaid, totalBillAmt]);

  useEffect(() => {
    console.log("breadcrumbs: ", breadcrumbItems);
    console.log("patientBasicInfo: ", patientBasicInfo, "\n", visitList);
  }, [breadcrumbItems, patientBasicInfo]);

  useEffect(() => {
    console.log("Updated loc: ", selectedLocation);
    console.log("invoiceCount:useeffect ", invoiceCount);
  }, [selectedLocation, invoiceCount]);

  useEffect(() => {
    console.log("newInvoiceItems in useeffect: ", newInvoiceItems);
    // console.log("Redux State:", {
    //   newInvoiceItems,
    //   erpDetailState: useSelector(state => state.erpDetailState)
    // });
    console.log("productSelected: ", productSelected);
    let productSelectd = productSelected;
    if (
      productSelectd &&
      productSelectd.type === ERP_VISIT_FIN_SUMMARY_TYPE_INV
    ) {
      setValue("3");
      setInvoiceViewTabName(true);
    } else if (
      productSelectd &&
      productSelectd.type === ERP_VISIT_FIN_SUMMARY_TYPE_SO
    ) {
      setValue("3");
    }
  }, [newInvoiceItems, productSelected]);

  const getPatientProfile = () => {
    let patId = patientId;
    let visId=visitId;
    dispatch(
      patientActions.getPatientProfile(patId, visId,(resCb) => {
        if (resCb) {
          console.log("patientprofile", resCb);
          setErrorMessages(
            Array.isArray(resCb?.errorMessages) ? resCb.errorMessages[0] : "",
          );
          setVisitList(resCb);
          console.log("visitListttttt", resCb);

          setLoading(false);
          // refresh room info any time we receive new patient details
          loadRoomInfo();
        }
      }),
    );
  };

  const handleChange = (newValue) => {
    const allowedValue = newValue === "5" && !isVedamaayu ? "2" : newValue;

    console.log(
      "handleChange patientId: ",
      patientId,
      " visitId : ",
      visitId,
      " new Value: ",
      allowedValue,
    );
    if (value !== allowedValue) {
      setValue(allowedValue);
      if (allowedValue != "3") {
        getPatientProfile();
        setInvoiceViewTabName(false);
        // if (ROLE_KEYS.InsuranceDesk === currentUserRole) {
        //   setInvoiceViewTabName(true);
        // } else {
        //   setInvoiceViewTabName(false);
        // }
      }
      setProductSelected("");
      getBreadcrumbItems(allowedValue);
    }
  };

  const showMessageStrip = (message, msgtype) => {
    var ServerResVal = ServerRes;
    if (msgtype == "success") {
      ServerResVal.success = message;
    } else {
      ServerResVal.error = message;
    }
    setServerRes({ ...ServerResVal });
    setTimeout(() => {
      closeAlert();
    }, 2000);
  };

  const closeAlert = (e) => {
    setServerRes({ ..."" });
  };

  const showPaymentPage = (data) => {
    console.log("showPaymentPage: ", data);
    console.log("ERP_LABEL_PAYMENT_BACK_ICON : ", ERP_LABEL_PAYMENT_BACK_ICON);
    console.log(
      "ERP_LABEL_PAYMENT_CLOSE_ICON : ",
      ERP_LABEL_PAYMENT_CLOSE_ICON,
    );

    if (data.type === ERP_LABEL_PAYMENT_CLOSE_ICON) {
      setProductSelected("");
      setPaymentInitialisedMode("");
      setBillClearAmtOverride(undefined);
      setInvoicePaymentDetails("");
      setValue("2");
    } else if (
      data.type === ERP_LABEL_PAYMENT_BACK_ICON ||
      data.type === ERP_BILLING_TYPE_SO
    ) {
      if (invoicePaymentDetails) {
        setValue("3");
        if (
          data.invDetails.billingStage ===
          ERP_INVOICE_BILLING_STAGE_BACK_TO_BILLING_FROM_PAYMENT
        ) {
          setProductSelected({ ...data.invDetails });
        }
      } else {
        setInvoicePaymentDetails("");
        setProductSelected("");
        setValue("2");
      }
      setBillClearAmtOverride(undefined);
    }
    setShowPayment(!showPayment);
    setShowOutstandingBill(false);
  };

  const updateGridDataFromProdSearch = (prod) => {
    console.log("selected product : ", prod);
    console.log("newInvoiceItems : ", newInvoiceItems);
    const currentItems = newInvoiceItems || []; // Ensure we have an array

    // Create new row object
    const newRow = {
      date: Date.now(),
      slNo: currentItems.length + 1,
      serviceName: prod.typePackage ? prod.name : prod.packageServiceName,
      description: prod.typePackage ? prod.name : prod.packageServiceName,
      originalPrice: prod.typePackage ? prod.sellPriceTax : prod.sellPricetax,
      updatedOriginalPrice: prod.typePackage
        ? prod.sellPriceTax
        : prod.sellPricetax,
      charges: prod.priceDiscountIncTax,
      discountCharges: prod.sellPricetax - prod.priceDiscountIncTax,
      originalDiscountCharges: prod.priceDiscountIncTax,
      quantity: 1,
      price: prod.priceDiscountIncTax,
      type: ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE,
      typePackage: prod.typePackage,
      productDetail: prod,
      prodId: prod?.reference,
      soId: null,
      isKPCreditDiscountApplicable: !(
        prod.isDoctor === "true" && prod.gvId > 0 && org.orgCode === ORG_DETAILS.MNH_DETAILS.orgCode
      ),
      action: "delete",
      value: value,
      billable: prod.billable,
      serviceList: [],
    };

    // If it's a package, also create rows for each service in the serviceList
    if (prod.typePackage && Array.isArray(prod.serviceList)) {
      prod.serviceList.forEach((service, index) => {
        const serviceRow = {
          date: Date.now(),
          slNo: currentItems.length + 1 + index, // continue serial number
          serviceName: service.packageServiceName,
          description: service.packageServiceName,
          originalPrice: service.sellPricetax,
          updatedOriginalPrice: service.sellPricetax,
          charges: service.priceDiscountIncTax,
          originalDiscountCharges: service.priceDiscountIncTax,
          quantity: 1,
          price: service.priceDiscountIncTax,
          type: ERP_VISIT_FIN_SUMMARY_TYPE_NEW_INVOICE,
          typePackage: false, // child rows are not packages themselves
          productDetail: service,
          prodId: service?.reference,
          isKPCreditDiscountApplicable: !(service.isDoctor === "true" && service.gvId > 0 && org.orgCode === ORG_DETAILS.MNH_DETAILS.orgCode),
          soId: null,
          action: "delete",
          value: value,
          billable: service.billable,
        };
        newRow.serviceList.push(serviceRow);
        // newRows.push(serviceRow);
      });
    }
    setProductSelected(newRow);
    // Always dispatch with the complete new array
    const updatedItems = [...currentItems, newRow];
    dispatch(successDispatch(ERP_TABLE_NEW_INVOICE_ITEMS, updatedItems));
  };

  const closeMessageStrip = () => {
    console.log("closing msg strip fn in doctorlist");
    setShowMsgStrip(!showMsgStrip);
  };

  const getBreadcrumbItems = (selectedTab) => {
    let bredCrmbsList = [];
    const role_name = JSON.parse(localStorage.getItem("role"));
    if (
      role_name === ROLE_KEYS.Ultrasound ||
      role_name === ROLE_KEYS.LabAdmin ||
      role_name === ROLE_KEYS.XRay
    ) {
      const backItems = { label: "BACK", path: `/patient`, isBack: true };
      bredCrmbsList.push(backItems);

      const baseItems = [
        { label: "Patient" },
        {
          label: patientBasicInfo
            ? helperServices.getFullName(
                patientBasicInfo.fname,
                patientBasicInfo.mname,
                patientBasicInfo.lname,
              )
            : patientId || "N/A",
        },
      ];
      bredCrmbsList.push(...baseItems);
    } else {
      const baseItems = [
        { label: "Patient", path: "/Home" },
        {
          label: patientBasicInfo
            ? helperServices.getFullName(
                patientBasicInfo.fname,
                patientBasicInfo.mname,
                patientBasicInfo.lname,
              )
            : patientId || "N/A",
          path: `/PatientSections/${patientId}/${visitId}`,
        },
      ];
      bredCrmbsList.push(...baseItems);
    }
    const thirdItem =
      selectedTab == 1
        ? { label: "Services", path: `/billing/${patientId}/${visitId}` }
        : selectedTab == 2
          ? {
              label: "Financial Summary",
              path: `/billing/${patientId}/${visitId}`,
            }
          : selectedTab == 5
            ? {
                label: "Membership Services",
                path: `/billing/${patientId}/${visitId}`,
              }
            : { label: "New Invoice", path: `/billing/${patientId}/${visitId}` };

    bredCrmbsList.push(thirdItem);
    setBreadcrumbItems(bredCrmbsList);
    return bredCrmbsList;
  };

  const handleFinancialUpdate = (finsummary) => {
    console.log("handleFinancialUpdate : ", finsummary);
    setTotalBillAmt(finsummary["all"].totalBillAmount);
    if (finsummary["all"].totalReceivedAmount) {
      let advAmount = finsummary["all"].totalReceivedAmount;
      setTotalAdvPaid(advAmount);
    }
    let invoiceCount = finsummary.all.totalInvoiceCount;
    setInvoiceCount(invoiceCount);
    if (finsummary && finsummary.all) {
      setTotalDiscountAmount(finsummary.all.totalDiscountAmount.toFixed(2));
      setAllFinSummaryData(finsummary.all);
      const totalWithoutDiscount = finsummary["all"].totalGrossAmount;
      // finsummary["all"].totalBillAmount +
      // finsummary["all"].totalDiscountAmount;
      console.log(
        "Total without discount : ",
        totalWithoutDiscount,
        finsummary,
      );
      setTotalWithoutDiscount(totalWithoutDiscount);
    }
  };

  const handleInvPaymentDetails = (invPaymentDetail) => {
    console.log("handleInvPaymentDetails: ", invPaymentDetail);
    // invPaymentDetails
    const invDetails = {
      ...invPaymentDetail,
      type: HMS_ERPPAYMENT_PAYMENT_TYPE.NEW_INVOICE_PAY_NOW,
    };
    console.log("invDetails: ", invDetails);
    setPaymentInitialisedMode(HMS_ERPPAYMENT_PAYMENT_TYPE.NEW_INVOICE_PAY_NOW);
    setInvoicePaymentDetails(invDetails);
    setProductSelected("");
    setShowPayment(true);
  };

  // Triggered from Visit Financial Summary CheckIcon to clear a specific invoice
  const handleClearInvoiceStart = (paymentDetail) => {
    console.log("handleClearInvoiceStart: ", paymentDetail);
    try {
      const amount = Number(paymentDetail?.amount || 0);
      setBillClearAmtOverride(isNaN(amount) ? 0 : amount);
      paymentDetail.rowData["netInvoiceClearAmt"] = amount;
      setInvoicePaymentDetails({ ...paymentDetail.rowData });
      setProductSelected("");
      setPaymentInitialisedMode(
        HMS_ERPPAYMENT_PAYMENT_TYPE.INVOICE_PAYMENT_FOR_SELECTED_INVOICES,
      );
      setShowOutstandingBill(false);
      setShowPayment(true);
    } catch (e) {
      console.error("handleClearInvoiceStart error:", e);
    }
  };

  const viewServicesInvDetails = (data) => {
    console.log("viewServicesInvDetails: ", data);

    if (ERP_INVOICE_WORKING_DATA_TYPE_VIEW_INVOICE === data.dataType) {
      console.log("view invoice : ", data);
      let allRows = data;
      setInvoiceViewTabName(true);
      const invDetails = [...allRows];
      dispatch(successDispatch(ERP_TABLE_NEW_INVOICE_ITEMS, invDetails));
      setProductSelected(invDetails);
      setValue("3");
    } else if (
      ERP_INVOICE_WORKING_DATA_TYPE_SO_GENERATE_INVOICE === data.dataType
    ) {
      let allRows = data;
      console.log(
        "ERP_INVOICE_WORKING_DATA_TYPE_SO_GENERATE_INVOICE: ",
        allRows,
      );
      // setProductSelected(allRows);
      // Always dispatch with the complete new array
      const updatedItems = [...allRows];
      dispatch(successDispatch(ERP_TABLE_NEW_INVOICE_ITEMS, updatedItems));
      setProductSelected(updatedItems);
    }
  };
  const handleFinSummarycardAction = (type) => {
    console.log("Parent received action type:", type);
    if (type === 0) {
      setShowPayment(true);
    }
    if (type === 3) {
      //show outstanding bill page
      setBillClearAmtOverride(undefined);
      handleOpenOutstandingBillPage();
    }
    if (type === 1) {
      setPaymentInitialisedMode(
        HMS_ERPPAYMENT_PAYMENT_TYPE.REFUND_PAYMENT_ONLY,
      );
      //show outstanding bill page
      setShowPayment(true);
    }
  };

  const handleSelectedLocation = (locationDetail) => {
    console.log("handleSelectedLocation ERPBilling: ", locationDetail);
    setSelectedLocation(locationDetail);
  };

  const handleCloseOutstandingBillPage = () => {
    setShowOutstandingBill(false);
  };

  const handleOpenOutstandingBillPage = () => {
    setShowOutstandingBill(true);
    setShowPayment(true);
  };

  const handleClearProps = () => {
    setProductSelected("");
  };

  const handlePaymentRequestApproval = (paymentRequest) => {
    console.log("handlePaymentRequestApproval: ", paymentRequest);
    const amount = Number(paymentRequest?.requestedAmount || 0);
    setBillClearAmtOverride(isNaN(amount) ? 0 : amount);
    setInvoicePaymentDetails({ ...paymentRequest });
    setProductSelected("");
    setPaymentInitialisedMode(
      HMS_ERPPAYMENT_PAYMENT_TYPE.PAYMENTREQUEST_ADVANCE_PAYMENT_ONLY,
    );
    setShowOutstandingBill(false);
    setShowPayment(true);
  };

  const generateInvoiceReportPreview = async (
    reportType,
    actionType,
    templateReportType,
  ) => {
    setIsDisable(true);
    setLoading(true);
    setIsBackgroundTransparent(true);
    console.log(
      "generateConsolidatedInvoice loc details : ",
      allMasterLocationDetails,
    );
    let ticketId = null;
    let customerId = patientBasicInfo.erpCustId;
    // let reportType = "consolidated";
    let locationIds = [];
    if (!allMasterLocationDetails) {
      const masterLocationResponse = await getMasterLocationDetails();
      locationIds = helperServices.getBillableLocationIds(
        masterLocationResponse?.masterlocations || masterLocationResponse,
      );
    } else {
      const matchingElement = allMasterLocationDetails?.find(
        (element) =>
          element?.locationKey === MASTER_LOCATION_DATA_LOCATION_KEY.ALL,
      );
      locationIds =
        matchingElement?.locationDetails?.erpLocationDetails?.[0]?.locationid;
    }
    let insurersFlag =
      JSON.parse(localStorage.getItem("role")) &&
      JSON.parse(localStorage.getItem("role")) === ROLE_KEYS.InsuranceDesk
        ? true
        : false;
    if (
      insurersFlag &&
      templateReportType === HMS_REPORT_TEMPLATE_TYPE.CONSOLIDATED_INVOICE
    ) {
      setInsurerData({
        ticketId,
        visitId,
        reportType,
        locationIds,
        templateReportType,
        customerId,
      });

      setHikeUpService(true);
    } else {
      const printPDF = await getInvPDFObject(
        ticketId,
        visitId,
        customerId,
        reportType,
        locationIds,
      );
      console.log("printPDF: ", printPDF);
      let invoiceReports = printPDF?.hmsInvReportDTOList || [];

      if (
        reportType === INVOICE_REPORT_TYPE.ESTIMATED &&
        !hasInvoiceItems(invoiceReports) &&
        printDataPayload.invoiceTicketIds?.length
      ) {
        const invoiceResponse = await getInvPDFObject(
          printDataPayload.invoiceTicketIds,
        );
        invoiceReports = buildEstimateFromInvoices(
          invoiceResponse?.hmsInvReportDTOList,
        );
      }
      // const blob = new Blob([printPDF], { type: "application/pdf" });
      // if (printPDF instanceof Blob) {

      //convert blob to url and open in new tab
      // const blobURL = URL.createObjectURL(printPDF);
      // const pdfWindow = window.open(blobURL, "_blank");

      const data = await generateBillHtml(
        invoiceReports,
        templateReportType,
        org?.orgCode,
      );
      console.log("Generated HTML Data: ", data);

      setPrintData(data);
      setTriggerAction(actionType);
      if (data) {
        setIsDisable(false);
        setLoading(false);
        setIsBackgroundTransparent(false);
      }
    }

    // } else {
    //   // const blobURL = printPDF;
    //   // const pdfWindow = window.open(blobURL, "_blank");
    //   // const blob = new Blob([printPDF], { type: "text/html" });
    //   const url = URL.createObjectURL(printPDF);
    //   window.open(url, "_blank");
    // }

    // Navigate programmatically and pass state
    // navigate(`/invoice/${invoiceId}`, {
    //   state: {
    //     type: invoiceType,
    //     locationids: invoiceLocationIds,
    //   },
    // });
    // setShowViewInvoicePage(true);
    // viewInvoicePage(blobURL);
  };

  const printInvoicePDF = async (reportType) => {
    console.log("print inv reportType: ", reportType);

    console.log("print inv patientBasicInfo: ", patientBasicInfo);

    let ticketId = null;
    // let visitId = null;
    let customerId = patientBasicInfo.erpCustId;
    let locationIds = [];
    if (!allMasterLocationDetails) {
      const allMastrLocDetails = getMasterLocationDetails();
      locationIds = helperServices.getBillableLocationIds(allMastrLocDetails);
    } else {
      const matchingElement = allMasterLocationDetails?.find(
        (element) =>
          element?.locationKey === MASTER_LOCATION_DATA_LOCATION_KEY.ALL,
      );
      locationIds =
        matchingElement?.locationDetails?.erpLocationDetails?.[0]?.locationid;
    }
    const printPDF = await getInvPDFObject(
      ticketId,
      visitId,
      customerId,
      reportType,
      locationIds,
    );
    // const blobURL = URL.createObjectURL(printPDF);
    // Assuming 'printPDF' is the variable you want to check
    if (printPDF instanceof Blob) {
      // You can proceed with creating the FormData and sending it
      console.log("printPDF is indeed a Blob object!");

      // Create FormData if using multipart/form-data
      const formData = new FormData();
      formData.append("file", printPDF, "invoice.pdf");

      // const arrayBuffer = await printPDF.arrayBuffer();

      const printResp = await printPDFFile(formData);
      console.log("printResp :", printResp);
    } else {
      console.error("printPDF is NOT a Blob object. It is:", printPDF);
      // Handle the case where it's not a Blob (e.g., show an error, convert it, etc.)
    }
  };

  const financialData = [
    {
      title: FINANCIALCARDSUMMARYTITLE.AMOUNTCREDITED,
      finsummary: allFinSummaryData,
      amount: totalAdvPaid.toFixed(2) || "0.00",
      lastUpdatedTimeStamp: `${currentDate.getMonth()} ${currentDate.getDate()}`,
      type: 0, //Add card Icon
    },
    {
      title: FINANCIALCARDSUMMARYTITLE.BILLABLETOTAL,
      finsummary: allFinSummaryData,
      amount: totalBillAmt.toFixed(2),
      lastUpdatedTimeStamp: `${currentDate.getMonth()} ${currentDate.getDate()}`,
      type: 1, //CachedIcon
    },
    {
      title: FINANCIALCARDSUMMARYTITLE.TOTALWITHOUTDISCOUNT,
      finsummary: allFinSummaryData,
      amount: totalWithoutDiscount.toFixed(2),
      leftTitle: FINANCIALCARDSUMMARYTITLE.TOTALDISCOUNT,
      leftAmount: totalDiscountAmount,
      lastUpdatedTimeStamp: `${currentDate.getMonth()} ${currentDate.getDate()}`,
      type: 3, //CachedIcon
    },
    {
      title: FINANCIALCARDSUMMARYTITLE.TOTALBALANCE,
      finsummary: allFinSummaryData,
      amount: balanceAmount.toFixed(2),
      lastUpdatedTimeStamp: `${currentDate.getMonth()} ${currentDate.getDate()}`,
      type:
        allFinSummaryData &&
        allFinSummaryData.invPendingPaymentAmt &&
        allFinSummaryData.invPendingPaymentAmt > 0 &&
        allFinSummaryData.creditBalance &&
        allFinSummaryData.creditBalance > 0
          ? 2
          : 4,
      // 'totalReceivedAmount': 0,
      // 'totalBillAmount': 0,
      // 'invPendingPaymentAmt': 0,
      // 'totalSalesOrderAmt': 0,
      // 'totalReceivedAdvanceAmt': 0,)2, //CachedIcon
    },
  ];

  const moveToBill = () => {
    setOnMoveToBillModalOpen(true);
  };

  const roomDealocated = () => {
    setOpenRoomDealocate(true);
  };

  const closeVisitCompleteModal = () => {
    console.log("Button clicked");
    setOnMoveToBillModalOpen(false);
  };

  const fetchSalesOrder = async (shouldShowAdd = true) => {
    try {
      console.log(
        `patientId : ${patientId} :: visitId : ${visitId} ::  locationId : ${selectedLocation}`,
      );

      let locDetail = selectedLocation;
      let loc = [];
      if (
        locDetail &&
        locDetail.locationDetails &&
        locDetail.locationKey === "all"
      ) {
        loc = locDetail.locationDetails.erpLocationDetails[0].locationid;
      } else {
        loc = await helperServices.getLocationIdByvisitType(
          allMasterLocationDetails,
          patientBasicInfo?.visit?.type,
        );
      }
      console.log(
        `patientId : ${patientId} :: visitId : ${visitId} ::  locationId : ${loc}`,
      );

      // if(loc && loc.length>0){
      const response = await getAllSalesOrder(patientId, visitId, loc);
      let updatedRows = null;
      if (response) {
        console.log("getAllSalesOrder : response : ", response);
        updatedRows = getAllRowData(response.serviceList);
      }
      // }
      return updatedRows;
    } catch (error) {
      console.error("Error fetching sales order:", error);
      // You might want to add error handling here, such as setting an error state
      return [];
    }
  };

  function getAllRowData(serviceList) {
    let uRowData = [];
    console.log("get all row i/p data : ", serviceList);

    if (serviceList != null) {
      serviceList.forEach((service) => {
        // soData.salesOrderLineItems.forEach((soLineOrderItems) => {
        // let amount = soLineOrderItems.price * soLineOrderItems.units;
        let row = {
          soId: service.soId,
          serviceName: service.productName,
          prodId: service.prodId,
          productName: service.productName,
          description: service.description,
          originalPrice: service.originalPrice,
          updatedOriginalPrice: service.originalPrice,
          quantity: service.quantity,
          amount: service.amount,
          price: service.amount,
          location: ERP_LOCATION_MAP_LOCATION_NAME[service.locationId],
          locationId: service.locationId,
          voucherList: "",
          doctor: "",
          action: "",
          soLinID: service.salesLineId,
          patientId: service.patientId,
          visitId: service.visitId,
        };
        uRowData.push(row);
        // });
        console.log("salesOrder : ", service);
      });
    }
    return uRowData;
  }

  const handleAllInvPrint = async () => {
    const { invoiceTicketIds, advanceRefundRows } = printDataPayload;
    console.log("printclicked", invoiceTicketIds);
    if (!invoiceTicketIds?.length && !advanceRefundRows?.length) {
      console.log("No invoices to print");
      return;
    }
    try {
      const response = await getInvPDFObject(invoiceTicketIds);

      const htmlContent = await generateBillHtml(
        response.hmsInvReportDTOList,
        HMS_REPORT_TEMPLATE_TYPE.PRINT_ALL_INVOICE,
        org?.orgCode,
        advanceRefundRows,
      );

      setPrintData(htmlContent);
      setTriggerAction("print");
    } catch (error) {
      console.error("Department print failed:", error);
      // alert("Failed to generate department print preview.");
      showMessageStrip("Failed to generate department print preview", "error");
    } finally {
      setIsDisable(false);
    }
  };

  const handleExceldownload = async () => {
    const { invoiceTicketIds, advanceRefundRows } = printDataPayload;

    if (!invoiceTicketIds?.length) return;

    try {
      const response = await getInvPDFObject(invoiceTicketIds);
      console.log("tickedid list resp", response);
      const excelBuffer = await generateInvoiceExcel(
        response.hmsInvReportDTOList,
      );

      // Download file
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      link.download = `PrescriptionReport_${Date.now()}.xlsx`;
      link.click();
    } catch (err) {
      console.error("Excel download failed", err);
      // alert("Failed to download Excel.");
      showMessageStrip("Failed to download Excel", "error");
    }
  };

  const handleSummaryInvPrint = async () => {

    const { invoiceTicketIds, advanceRefundRows } = printDataPayload;
    console.log("printclicked", invoiceTicketIds);
    if (!invoiceTicketIds?.length && !advanceRefundRows?.length) {
      console.log("No invoices to print");
      return;
    }
    try {
      const response = await getInvPDFObject(invoiceTicketIds);

      const htmlContent = await generateBillHtml(
        response.hmsInvReportDTOList,
        HMS_REPORT_TEMPLATE_TYPE.PRINT_INVOICE_SUMMARY,
        org?.orgCode,
      );

      setPrintData(htmlContent);
      setTriggerAction("print");
    } catch (error) {
      console.error("Department print failed:", error);
      // alert("Failed to generate department print preview.");
      showMessageStrip("Failed to generate department print preview", "error");
    } finally {
      setIsDisable(false);
    }
  };

  const fetchMoveToBilling = async () => {
    try {
      console.log(
        `patientId : ${patientId} :: visitId : ${visitId} ::  locationId : ${selectedLocation}`,
      );

      let locDetail = selectedLocation;
      let loc = [];
      if (
        locDetail &&
        locDetail.locationDetails &&
        locDetail.locationKey === "all"
      ) {
        loc = locDetail.locationDetails.erpLocationDetails[0].locationid;
      } else {
        loc = await helperServices.getLocationIdByvisitType(
          allMasterLocationDetails,
          patientBasicInfo?.visit?.type,
        );
      }
      console.log(
        `patientId : ${patientId} :: visitId : ${visitId} ::  locationId : ${loc}`,
      );

      console.log("patientBasicInfo: ", patientBasicInfo);
      let locationIds = [];
      if (!allMasterLocationDetails) {
        const allMastrLocDetails = getMasterLocationDetails();
        locationIds = helperServices.getBillableLocationIds(allMastrLocDetails);
      } else {
        const matchingElement = allMasterLocationDetails?.find(
          (element) =>
            element?.locationKey === MASTER_LOCATION_DATA_LOCATION_KEY.ALL,
        );
        locationIds =
          matchingElement?.locationDetails?.erpLocationDetails?.[0]?.locationid;
      }
      const request = {
        organisationCode: null,
        startDate: null,
        endDate: null,
        patientId: patientId,
        erpCustId: patientBasicInfo.erpCustId,
        visitId: visitId,
        locationIds: locationIds,
        reportType: INVOICE_REPORT_TYPE.ESTIMATED,
        ticketIds: null,
      };
      // if(loc && loc.length>0){
      const response = await getFinalBillObject(request);
      let updatedRows = null;
      if (response) {
        console.log("getAllSalesOrder : response : ", response);
        updatedRows = getMoveToBillingRowData(response);
      }
      // }
      return updatedRows;
    } catch (error) {
      console.error("Error fetching sales order:", error);
      // You might want to add error handling here, such as setting an error state
      return [];
    }
  };

  function getMoveToBillingRowData(hmsBillInvObj) {
    let uRowData = [];
    console.log("get all row i/p data : ", hmsBillInvObj);

    if (hmsBillInvObj != null) {
      hmsBillInvObj.forEach((billObj) => {
        const billItems = billObj.billingItem;
        billItems.forEach((billItem) => {
          // soData.salesOrderLineItems.forEach((soLineOrderItems) => {
          // let amount = soLineOrderItems.price * soLineOrderItems.units;
          let row = {
            slNo: billItem.slNo,
            soId: billItem.soId,
            serviceName: billItem.serviceName,
            prodId: billItem.productId,
            productName: billItem.serviceName,
            description: billItem.serviceName,
            originalPrice: billItem.gross,
            updatedOriginalPrice: billItem.gross,
            quantity: billItem.units,
            amount: billItem.discount,
            price: billItem.charges,
            location: helperServices.getFirstLocationNameByLocationId(
              allMasterLocationDetails,
              billItem.locationId,
            ),
            locationId: billItem.locationId,
            voucherList: "",
            doctor: "",
            action: "",
            soLinID: billItem.soLineId,
            patientId: billItem.patientId,
            visitId: billItem.visitId,
            isKPCreditDiscountApplicable:
              billItem.isKPCreditApplicable === undefined
                ? true
                : billItem.isKPCreditApplicable,
            ticketId: billItem.ticketId,
            ticketLineId: billItem.ticketLineId,
            billNumber: billItem.billNumber,
            netAmount: billItem.netAmount,
            discount: billItem.discount,
            taxRate: billItem.taxRate,
            isConsolidated: billItem.isConsolidated,
          };
          uRowData.push(row);
          console.log("salesOrder : ", billItem);
          // });
        });
      });
    }
    return uRowData;
  }
  const handleGenerateInvoice = async (event) => {
    setOnMoveToBillModalOpen(false);
    if (event != null && event !== undefined) {
      const updatedRows = await fetchMoveToBilling();
      if (!updatedRows || updatedRows.length === 0) {
        return;
      }
      const visitType = visitList?.visit?.type;
      // const targetName =
      //   visitType === "InPatient"
      //     ? ERP_PATIENT_VISIT_TYPE_IN_PATIENT
      //     : visitType === "OutPatient"
      //     ? ERP_PATIENT_VISIT_TYPE_OUT_PATIENT
      //     : "";
      let loc =
        visitType === "InPatient" ? 0 : visitType === "OutPatient" ? 4 : "";

      // setLocationId(loc);
      // console.log("Delete clicked for row: ", props.data, event);
      console.log("Delete clicked for row: ");
      const SoList = {
        ...updatedRows,
        dataType: ERP_LABEL_MOVETOBILL,
        type: ERP_VISIT_FIN_SUMMARY_TYPE_SO,
      };
      console.log("data productSelected: ", SoList);
      //below line is to update the solist in the new invoice tab
      getPatientProfile();
      setProductSelected(SoList);
    }
  };

  const handleIsKpCashChange = (value) => {
    if (value) {
      setIsKpCash(true);
    } else {
      setIsKpCash(false);
    }
  };

  if (error) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        Error: {error}
      </div>
    );
  }

  if (!patientId || !visitId) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        Invalid patient or visit ID
      </div>
    );
  }

  if (
    showPayment &&
    helperServices.CheckAccessLevel(All_Component_Name.AdvancePayment)
  ) {
    return (
      <div className="ms-2">
        {/* <ERPPayment balAmount={balanceAmount} paymentTowards={invoicePaymentDetails} billClearAmt={allFinSummaryData.totalReceivedAmount - allFinSummaryData.invReceivedAmt} clearOutstandingBillType={showOutstandingBill ? ERP_OUTSTANDING_BILLS_TYPE_DIRECT_CLEAR : HMS_ERP_BILL_CLEAR_ADVANCE_TYPE.ERP_ADVANCE_AMOUNT_TYPE_ADVANCE_PAYMENT} closePaymentPage={showPaymentPage} serverResposnes={showMessageStrip} /> */}
        <ProtectedComponent
          componentName={All_Component_Name.AdvancePayment} // or whatever name you use for ERPPayment
          component={ERPPayment} // make sure ERPPayment is exported in Components
          patientId={patientId}
          visitId={visitId}
          balAmount={balanceAmount}
          paymentTowards={invoicePaymentDetails}
          paymentInitialisedMode={paymentInitialisedMode}
          billClearAmt={
            billClearAmtOverride !== undefined
              ? billClearAmtOverride
              : allFinSummaryData?.totalReceivedAmount -
                allFinSummaryData?.invReceivedAmt
          }
          clearOutstandingBillType={
            showOutstandingBill
              ? HMS_ERP_BILL_CLEAR_ADVANCE_TYPE.ERP_OUTSTANDING_BILLS_TYPE_DIRECT_CLEAR
              : HMS_ERP_BILL_CLEAR_ADVANCE_TYPE.ERP_ADVANCE_AMOUNT_TYPE_ADVANCE_PAYMENT
          }
          closePaymentPage={showPaymentPage}
          serverResposnes={showMessageStrip}
        />
      </div>
    );
  }

  const handleDischargeFlag = () => {
    const flag = isDischarged
      ? VISIT_BILLING_STATUS.BILLING_STATUS_ENABLED
      : VISIT_BILLING_STATUS.BILLING_STATUS_DISABLED;

    dispatch(
      patientActions.PatientVisitBillingStatus(visitId, flag, (resCb) => {
        if (resCb?.state) {
          setIsDischarged(
            flag === VISIT_BILLING_STATUS.BILLING_STATUS_DISABLED,
          );
          getPatientProfile();
        }
      }),
    );
  };

  // if (showOutstandingBill) {
  //   return (
  //     <div className="ms-2">
  //       <ERPOutStandingBills financialSummaryData={allFinSummaryData} clearOutstandingBillType={ERP_OUTSTANDING_BILLS_TYPE_DIRECT_CLEAR} closeOutstandingBillPage={handleCloseOutstandingBillPage} />
  //     </div>
  //   )
  // }

  // if (value != '3') {
  return (
    // <div className="billingContainer">
    <>
      {errorMessages ? (
        <ErrorScreen message={errorMessages} />
      ) : (
        <>
          {ServerRes.success && (
            <Alert severity="success" className="alert-div">
              {ServerRes.success}

              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={(event) => closeAlert(event)}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            </Alert>
          )}
          {ServerRes.error && (
            <Alert severity="error" className="alert-div">
              {ServerRes.error}
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={(event) => closeAlert(event)}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            </Alert>
          )}
          <div className="billingContainer p-3 m-1 h-100">
            {/* <div className="summary-header"> */}
            {/* <button onClick={handleBack}>← Back to Financial Summary</button> */}

            <div className="d-flex justify-content-between pb-2">
              <div className="d-flex align-items-center">
                {returnTo && (
                  <ArrowBackIcon
                    onClick={handleBack}
                    style={{
                      cursor: "pointer",
                      fontSize: "23px",
                      marginRight: "8px",
                      marginBottom: "13px",
                    }}
                  />
                )}

                <Breadcrumbs crumbs={breadcrumbItems} />
              </div>
              <div>
                <Filter
                  selectedLocation={handleSelectedLocation}
                  currentLocation={selectedLocation}
                  visitType={patientBasicInfo?.visit?.type}
                />
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center pe-2">
              <div className="" onClick={() => handleFinSummarycardAction(0)}>
                <FinancialDataCardSummary
                  data={financialData[0]}
                  action={handleFinSummarycardAction}
                />
              </div>
              <div onClick={() => handleFinSummarycardAction(1)}>
                <FinancialDataCardSummary
                  data={financialData[1]}
                  action={handleFinSummarycardAction}
                />
              </div>
              <div onClick={() => handleFinSummarycardAction(2)}>
                <FinancialDataCardSummary
                  data={financialData[2]}
                  action={handleFinSummarycardAction}
                />
              </div>
              <div
                className="justify-content-center"
                onClick={() => handleFinSummarycardAction(3)}
              >
                <FinancialDataCardSummary
                  data={financialData[3]}
                  action={handleFinSummarycardAction}
                />
              </div>
            </div>
            {/* </div> */}

            <div className="billingPageTabNSearch mt-2">
              {/* <div style={{ marginLeft: '1em', marginTop: '.85em' }}> */}
              <div className="billingTabs col-8">
                <ProtectedComponent
                  componentName={All_Component_Name.ServiceListing}
                  component={() => (
                    <div
                      className={`${
                        value === "1"
                          ? "bg-white rounded p-2 "
                          : "text-body-emphasis"
                      } pointerCursor`}
                      onClick={() => handleChange("1")}
                    >
                      {ERP_LABEL_SERVICES}
                      <span> (F3)</span>
                    </div>
                  )}
                  pageType={COMPONENT_TYPE_NULL}
                  patientId={patientId}
                  visitId={visitId}
                  selectedlocationDetails={selectedLocation}
                  rowUpdate={productSelected}
                  closeNewInvoice={handleChange}
                  clearProps={handleClearProps}
                  visitList={visitList}
                  serverResposnes={showMessageStrip}
                />
                {/* <div
                className={`${
                  value === "1" ? "bg-white rounded p-2 " : "text-body-emphasis"
                } pointerCursor`}
                onClick={() => handleChange("1")}
                >
                {ERP_LABEL_SERVICES}
                  </div> */}
                <div
                  className={`${
                    value === "2"
                      ? "bg-white rounded p-2"
                      : "text-body-emphasis"
                  } pointerCursor`}
                  onClick={() => handleChange("2")}
                >
                  {ERP_LABEL_VISIT_FIN_SUMMARY} (F4)
                </div>

                <div
                  className={`${
                    value === "3"
                      ? "bg-white rounded p-2"
                      : "text-body-emphasis"
                  } pointerCursor`}
                  onClick={() => handleChange("3")}
                >
                  {invoiceViewTabName &&
                  helperServices.CheckAccessLevel(
                    All_Component_Name.ViewInvoice,
                  )
                    ? ERP_LABEL_VIEW_INVOICE
                    : ERP_LABEL_NEW_INVOICE}{" "}
                  (F5)
                </div>

                <ProtectedComponent
                  componentName={All_Component_Name.HMSPaymentRequest}
                  component={() => (
                    <div
                      className={`${
                        value === "4"
                          ? "bg-white rounded p-2 "
                          : "text-body-emphasis"
                      } pointerCursor`}
                      onClick={() => handleChange("4")}
                    >
                      {ERP_LABEL_ADVANCE_REQUEST}
                    </div>
                  )}
                  pageType={COMPONENT_TYPE_NULL}
                />
                {isVedamaayu && (
                  <div
                    className={
                      value === "5"
                        ? "bg-white rounded p-2 pointerCursor"
                        : "text-body-emphasis pointerCursor"
                    }
                    onClick={() => handleChange("5")}
                  >
                    Membership Services
                  </div>
                )}
              </div>
              <DataContext.Provider
                value={{
                  productSelected,
                  setProductSelected,
                  locationId: selectedLocation,
                  setLocationId: setSelectedLocation,
                }}
              >
                {/* </div> */}
                <div
                  className={`billingPage-ERPProdSearch erpSearchProd show searchSelectWrapper ${
                    value == "5" ? "d-none" : "col-4"
                  }`}
                >
                  {patientId &&
                    visitId &&
                    value == "1" &&
                    value != "2" &&
                    value != "3" &&
                    value != "4" &&
                    !invoiceViewTabName &&
                    // ((patientBasicInfo !== null &&
                    //   patientBasicInfo.visit !== null &&
                    //   patientBasicInfo.visit.internalStatus ===
                    //     PATIENT_VISIT_INTERNAL_STATUS.MOVED_TO_BILLING) ||
                    patientBasicInfo?.visit?.internalStatus ===
                      PATIENT_VISIT_INTERNAL_STATUS.BOOKED &&
                       visitStatus !== "close" && (
                      <div className="search-bar-wrapper">
                        <ProtectedComponent
                          componentName={All_Component_Name.ProductSearch}
                          component={ERPProductSearch}
                          pageType={COMPONENT_TYPE_NULL}
                          patientId={patientId}
                          visitId={visitId}
                          selectedLocationDetails={selectedLocation}
                          productSelected={updateGridDataFromProdSearch}
                          searchInputRef={searchInputRef}
                        />
                      </div>
                    )}
                  {patientId &&
                    visitId &&
                    value == "3" &&
                    value != "1" &&
                    value != "2" &&
                    value != "4" &&
                    !invoiceViewTabName &&
                    (!patientBasicInfo?.visit?.billingStatus ||
                      patientBasicInfo?.visit?.billingStatus !==
                        VISIT_BILLING_STATUS.BILLING_STATUS_DISABLED) &&
                    ((patientBasicInfo?.visit &&
                      (patientBasicInfo.visit.internalStatus ===
                        PATIENT_VISIT_INTERNAL_STATUS.MOVED_TO_BILLING ||
                        patientBasicInfo.visit.internalStatus ===
                          PATIENT_VISIT_INTERNAL_STATUS.Force_Close) &&
                      value !== "1") ||
                      (patientBasicInfo?.visit?.internalStatus ===
                          PATIENT_VISIT_INTERNAL_STATUS.BOOKED && visitStatus !== "close") ||
                      !!fromQuoteId) && (
                      <div className="search-bar-wrapper">
                        <ProtectedComponent
                          componentName={All_Component_Name.ProductSearch}
                          component={ERPProductSearch}
                          pageType={COMPONENT_TYPE_NULL}
                          patientId={patientId}
                          visitId={visitId}
                          selectedLocationDetails={selectedLocation}
                          productSelected={updateGridDataFromProdSearch}
                          searchInputRef={searchInputRef}
                        />
                      </div>
                    )}
                  {value == "3" &&
                    !invoiceViewTabName &&
                    (!patientBasicInfo?.visit?.billingStatus ||
                      patientBasicInfo?.visit?.billingStatus !==
                        VISIT_BILLING_STATUS.BILLING_STATUS_DISABLED ) && visitStatus !== "close" && (
                      <div className="select-dropdown-wrapper">
                        <FormControl>
                          <Select
                            name="isKpCash"
                            className=""
                            value={isKpCash}
                            // disabled={callType === "Edit"}
                            onChange={(event) =>
                              handleIsKpCashChange(event.target.value)
                            }
                          >
                            <MenuItem value={true}>Cash</MenuItem>
                            <MenuItem value={false}>Credit</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    )}
                </div>
              </DataContext.Provider>
            </div>

            <DataContext.Provider
              value={{ productSelected, setProductSelected }}
            >
              {value == "1" && (
                <ProtectedComponent
                  componentName={All_Component_Name.ServiceListing}
                  component={ERPServicesList}
                  pageType={COMPONENT_TYPE_NULL}
                  patientId={patientId}
                  visitId={visitId}
                  selectedLocationDetails={selectedLocation}
                  rowUpdate={productSelected}
                  closeNewInvoice={handleChange}
                  clearProps={handleClearProps}
                  visitList={visitList}
                  totalAdvPaid={totalAdvPaid}
                  serverResposnes={showMessageStrip}
                  searchInputRef={searchInputRef}
                  onFinancialUpdate={handleFinancialUpdate}
                />
              )}
              {(value == "2" || (isVedamaayu && value == "5")) && (
                <div style={{ display: value == "2" ? "block" : "none" }}>
                  <ProtectedComponent
                    componentName={All_Component_Name.FinancialSummary}
                    component={ERPVisitFinancialSummary}
                    pageType={COMPONENT_TYPE_COMPONENT}
                    patientId={patientId}
                    visitId={visitId}
                    pageMode={PAGE_MODE.SINGLE_INVOICE}
                    selectedLocationDetails={selectedLocation}
                    totalAdvPaid={totalAdvPaid}
                    onFinancialUpdate={handleFinancialUpdate}
                    invoiceSOView={viewServicesInvDetails}
                    onClearInvoiceStart={handleClearInvoiceStart}
                    onPrintDataUpdate={setPrintDataPayload}
                    serverResposnes={showMessageStrip}
                  />
                </div>
              )}
              {value == "3" && (
                <ProtectedComponent
                  componentName={
                    invoiceViewTabName &&
                    helperServices.CheckAccessLevel(
                      All_Component_Name.ViewInvoice,
                    )
                      ? All_Component_Name.ViewInvoice
                      : All_Component_Name.NewInvoice
                  }
                  component={ERPInvoice}
                  pageType={COMPONENT_TYPE_NULL}
                  patientId={patientId}
                  visitId={visitId}
                  selectedLocationDetails={selectedLocation}
                  rowUpdate={productSelected}
                  closeNewInvoice={handleChange}
                  invPaymentDetails={handleInvPaymentDetails}
                  clearProps={handleClearProps}
                  serverResposnes={showMessageStrip}
                  searchInputRef={searchInputRef}
                  isKpCash={isKpCash}
                  fromQuoteId={fromQuoteId}
                  fromLocKey={fromLocKey}
                  clearFromQuoteId={() => setFromQuoteId(null)}
                />
              )}
              {value == "4" && (
                <ProtectedComponent
                  componentName={All_Component_Name.HMSPaymentRequest}
                  component={HMSPaymentRequest}
                  pageType={COMPONENT_TYPE_NULL}
                  patientId={patientId}
                  visitId={visitId}
                  // selectedLocationDetails={selectedLocation}
                  onPaymentRequestApproved={handlePaymentRequestApproval}
                  closeNewInvoice={handleChange}
                  invPaymentDetails={handleInvPaymentDetails}
                  clearProps={handleClearProps}
                  serverResposnes={showMessageStrip}
                />
              )}
              {isVedamaayu && value == "5" && (
                <MembershipServices
                  patientId={patientId}
                  visitId={visitId}
                  readOnly={
                    patientBasicInfo?.visit?.status ===
                      PATIENT_VISIT_STATUS.CLOSED ||
                    visitStatus === PATIENT_VISIT_INTERNAL_STATUS.CLOSED
                  }
                  serverResposnes={showMessageStrip}
                />
              )}
            </DataContext.Provider>
            {/* {console.log(
              "patinrtonfo for consolidste button",
              patientBasicInfo
            )} */}
            <div className="d-flex justify-content-end align-items-center mx-2 gap-0">
              {/* {console.log("invoicecount  for consolidste button", invoiceCount)} */}
              {/* Always show Invoice Print dropdown when value = 2 */}

              {patientBasicInfo &&
                patientBasicInfo.visit &&
                patientBasicInfo.visit.type === PATIENT_VISIT_TYPE.INPATIENT &&
                (patientBasicInfo.visit.internalStatus ===
                  PATIENT_VISIT_INTERNAL_STATUS.MOVED_TO_BILLING ||
                  patientBasicInfo.visit.internalStatus ===
                    PATIENT_VISIT_INTERNAL_STATUS.Force_Close) &&
                invoiceCount > 0 &&
                allFinSummaryData &&
                allFinSummaryData.creditInvoiceCount > 0 &&
                value == "2" && (
                  <div className="d-flex justify-content-end aligh-items-center mx-2 gap-3">
                    <button
                      // className="btn btn-submit btn-primary ml-3"
                      className="p-2 my-2 bg-primary text-white rounded"
                      type="submit"
                      // variant="contained"
                      color="primary"
                      // sx={{ textTransform: "capitalize" }}
                      disabled={isDisable}
                      onClick={() =>
                        generateInvoiceReportPreview(
                          INVOICE_REPORT_TYPE.CONSOLIDATED,
                          "preview",
                          HMS_REPORT_TEMPLATE_TYPE.CONSOLIDATED_INVOICE,
                        )
                      }
                    >
                      {INVOICE_REPORT_TYPE_LABEL.CONSOLIDATED_INV_PREVIEW}
                    </button>
                    <button
                      // className="btn btn-submit btn-primary ml-3"
                      className="p-2 my-2 bg-primary text-white rounded"
                      type="submit"
                      // variant="contained"
                      color="primary"
                      // sx={{ textTransform: "capitalize" }}
                      disabled={isDisable}
                      onClick={() =>
                        generateInvoiceReportPreview(
                          INVOICE_REPORT_TYPE.CONSOLIDATED,
                          "print",
                          HMS_REPORT_TEMPLATE_TYPE.CONSOLIDATED_INVOICE,
                        )
                      }
                    >
                      {INVOICE_REPORT_TYPE_LABEL.CONSOLIDATED_INV_PRINT}
                    </button>
                  </div>
                )}

              {patientBasicInfo &&
                patientBasicInfo.visit &&
                (patientBasicInfo.visit.type === PATIENT_VISIT_TYPE.INPATIENT ||
                  patientBasicInfo.visit.type ===
                    PATIENT_VISIT_TYPE.OUTPATIENT) &&
                patientBasicInfo.visit.status === PATIENT_VISIT_STATUS.OPEN && (
                  <div className="d-flex justify-content-end align-items-center mx-2 gap-3">
                    {value === "1" && (
                      <>
                        <div className="d-flex align-items-center mx-2 gap-3">
                          <div className="dropdown invoice-dropdown">
                            <button
                              className="btn btn-primary dropdown-toggle p-2 my-2"
                              type="button"
                              id="moveToBillDropdown"
                              data-bs-toggle="dropdown"
                            >
                              {ERP_LABEL_MOVETOBILL}
                            </button>

                            <ul className="dropdown-menu">
                              {/* Move To Bill only when BOOKED */}
                              {patientBasicInfo?.visit?.internalStatus ===
                                PATIENT_VISIT_INTERNAL_STATUS.BOOKED &&
                                allFinSummaryData &&
                                allFinSummaryData.totalSalesOrderAmt > 0 && (
                                  <li>
                                    <button
                                      className="dropdown-item"
                                      onClick={moveToBill}
                                    >
                                      {ERP_LABEL_MOVETOBILL}
                                    </button>
                                  </li>
                                )}
                              {/* {(
  (roomInfo?.roomStatus?.bookstatus === "booked") ||
  patientBasicInfo?.roomList?.some(r => r?.roomStatus?.bookstatus === "booked")
) &&  allFinSummaryData &&
  !allFinSummaryData?.totalSalesOrderAmt >0 && (
    <li>
      <button
        className="dropdown-item"
        onClick={roomDealocated}
      >
       room dealocate
      </button>
    </li>
)} */}
                              {isRoomBooked &&
                                patientBasicInfo?.roomList?.length > 0 &&
                                allFinSummaryData &&
                                !allFinSummaryData?.totalSalesOrderAmt > 0 && (
                                  <li>
                                    <button
                                      className="dropdown-item"
                                      onClick={roomDealocated}
                                    >
                                      Room Deallocate
                                    </button>
                                  </li>
                                )}

                              {/* Mark / Undo Discharge */}
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={handleDischargeFlag}
                                >
                                  {isDischarged
                                    ? "Undo Discharge"
                                    : "Mark & Discharge"}
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>

                        {onMoveToBillModalOpen && (
                          <Components.MoveToBilling
                            visitList={visitList}
                            open={onMoveToBillModalOpen}
                            onModalClose={handleGenerateInvoice}
                            handleModelclose={() => {
                              // hide modal and refresh room status so deallocate button is hidden when no room
                              setOnMoveToBillModalOpen(false);
                              loadRoomInfo();
                            }}
                          />
                        )}
                        {openRoomDealocate && (
                          <Components.MoveToBilling
                            visitList={visitList}
                            open={true}
                            openRoomDealocate={true}
                            onModalClose={() => {
                              // Standalone room deallocation must close its own
                              // parent state. The move-to-billing callback leaves
                              // this dialog mounted and its backdrop can keep
                              // intercepting the billing page until a refresh.
                              setOpenRoomDealocate(false);
                              getPatientProfile();
                              loadRoomInfo();
                            }}
                            handleModelclose={() => {
                              setOpenRoomDealocate(false);
                              loadRoomInfo();
                            }}
                          />
                        )}
                      </>
                    )}
                  </div>
                )}

              {patientBasicInfo &&
                patientBasicInfo.visit &&
                (patientBasicInfo.visit.type === PATIENT_VISIT_TYPE.INPATIENT ||
                  patientBasicInfo.visit.type ===
                    PATIENT_VISIT_TYPE.OUTPATIENT) &&
                // patientBasicInfo.visit.internalStatus ===
                //   PATIENT_VISIT_INTERNAL_STATUS.BOOKED &&
                patientBasicInfo.visit.status === PATIENT_VISIT_STATUS.OPEN &&
                allFinSummaryData &&
                // allFinSummaryData.totalSalesOrderAmt &&
                // allFinSummaryData.totalSalesOrderAmt > 0 &&
                ["1", "2"].includes(value) && (
                  <div className="d-flex justify-content-end aligh-items-center mx-2 gap-3">
                    {["1"].includes(value) && <></>}
                    {patientBasicInfo.visit.type ===
                      PATIENT_VISIT_TYPE.INPATIENT &&
                      patientBasicInfo?.visit?.internalStatus !==
                        PATIENT_VISIT_INTERNAL_STATUS.MOVED_TO_BILLING &&
                      patientBasicInfo?.visit?.internalStatus !==
                        PATIENT_VISIT_INTERNAL_STATUS.Force_Close && (
                        <>
                          <button
                            // className="btn btn-submit btn-primary ml-3"
                            className="p-2 my-2 bg-primary text-white rounded"
                            type="submit"
                            // variant="contained"
                            color="primary"
                            // sx={{ textTransform: "capitalize" }}
                            disabled={isDisable}
                            onClick={() =>
                              generateInvoiceReportPreview(
                                INVOICE_REPORT_TYPE.ESTIMATED,
                                "preview",
                                HMS_REPORT_TEMPLATE_TYPE.ESTIMATE_INVOICE,
                              )
                            }
                          >
                            {INVOICE_REPORT_TYPE_LABEL.ESTIMATED_INV_PREVIEW}
                          </button>
                          <button
                            // className="btn btn-submit btn-primary ml-3"
                            className="p-2 my-2 bg-primary text-white rounded"
                            type="submit"
                            color="primary"
                            disabled={isDisable}
                            onClick={() =>
                              // printInvoicePDF(INVOICE_REPORT_TYPE.ESTIMATED, "print")
                              generateInvoiceReportPreview(
                                INVOICE_REPORT_TYPE.ESTIMATED,
                                "print",
                                HMS_REPORT_TEMPLATE_TYPE.ESTIMATE_INVOICE,
                              )
                            }
                          >
                            {INVOICE_REPORT_TYPE_LABEL.ESTIMATED_INV_PRINT}
                          </button>
                        </>
                      )}
                  </div>
                )}

              {value == "2" && (
                <div className="d-flex align-items-center mx-2 gap-3">
                  <div className="dropdown invoice-dropdown">
                    <button
                      className="btn btn-primary dropdown-toggle p-2 my-2"
                      type="button"
                      id="invoicePrintDropdown"
                      data-bs-toggle="dropdown"
                    >
                      Invoice Print
                    </button>

                    <ul
                      className="dropdown-menu"
                      aria-labelledby="invoicePrintDropdown"
                    >
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={handleAllInvPrint}
                        >
                          {INVOICE_REPORT_TYPE_LABEL.DEPARTMENT_INV_PRINT}
                        </button>
                      </li>

                      <li>
                        <button
                          className="dropdown-item"
                          onClick={handleSummaryInvPrint}
                        >
                          {INVOICE_REPORT_TYPE_LABEL.SUMMARY_INV_PRINT}
                        </button>
                      </li>
                      {console.log("selected location is ", selectedLocation)}
                      {console.log(
                        "MASTER_LOCATION_DATA_LOCATION_KEY.PHARMACY",
                        MASTER_LOCATION_DATA_LOCATION_KEY.PHARMACY?.toLowerCase(),
                      )}
                      {selectedLocation?.[0]?.locationKey?.toLowerCase() ===
                        MASTER_LOCATION_DATA_LOCATION_KEY.PHARMACY?.toLowerCase() && (
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={handleExceldownload}
                          >
                            {
                              INVOICE_REPORT_TYPE_LABEL.DOWNLOAD_PRESCREPTION_EXCEL
                            }
                          </button>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              )}
            </div>

            {/* <ERPTable /> */}
            {/* </div> */}

            {printdata && triggerAction && (
              <HeaderFooterComponent
                title="Invoice"
                data={printdata}
                triggerAction={triggerAction}
                onComplete={() => {
                  setPrintData(""); // clear data
                  setTriggerAction(""); // clear action
                  // console.log("Print action completed and state cleared.");
                }}
              />
            )}
            {hikeUpService && (
              <InvoiceViewer
                ticketId={InsurerData.ticketId}
                visitId={InsurerData.visitId}
                customerId={InsurerData.customerId}
                reportType={InsurerData.reportType}
                locationIds={InsurerData.locationIds}
                templateReportType={InsurerData.templateReportType}
                patientId={patientId}
                organisationDetail={org}
                closeInvoiceViewer={() => {
                  setHikeUpService(false);
                  setInsurerData(null);
                  setIsDisable(false);
                }}
              />
            )}
          </div>
        </>
      )}
    </>
  );
  // }

  // if (value == '3') {
  //   return (
  //     <div><ERPInvoice patientId={patientId} visitId={visitId} closeNewInvoice={handleChange} /></div>
  //   );
  // }
}
